import * as yup from "yup";
import {
  IRemaxGlobalStatusSync,
  remaxGlobalStatusSyncSchema
} from "../../remax-global/models/remax-global-status-sync";

// Definir subesquemas
const userTypeSchema = yup.object({
  id: yup.number().default(0),
  name: yup.string().default("")
});

const agencySchema = yup.object({
  id: yup.number().default(0),
  name: yup.string().default(""),
  phone: yup.string().default("")
});

// Esquema principal
const userSchema = yup
  .object({
    id: yup.number().default(0),
    name: yup.string().default(""),
    email: yup.string().default(""),
    personal_email: yup.string().nullable().default(null),
    joined_date: yup.string().default(""),
    phone: yup.string().default(""),
    identification: yup.string().default(""),
    identification_type: yup.string().nullable().default(null),
    fax: yup.string().nullable().default(null),
    is_collection_agent: yup.boolean().default(false),
    user_status: yup.string().default("Inactivo"),
    user_type: userTypeSchema.default({}),
    agency: agencySchema.default({}),
    exceptions: yup.mixed().nullable().default(null),
    score: yup.mixed().nullable().default(null),
    picture_url: yup.string().default(""),
    parent: yup.mixed().nullable().default(null),
    alterestate_token: yup.mixed().nullable().default(null),
    disabled_at: yup.mixed().nullable().default(null)
  })
  .concat(remaxGlobalStatusSyncSchema);

// Subesquema para el paginador
const paginationSchema = yup.object({
  first: yup.string().default(""),
  last: yup.string().default(""),
  prev: yup.mixed().nullable().default(null),
  next: yup.string().nullable().default(null)
});

// Esquema del meta
const metaSchema = yup.object({
  current_page: yup.number().default(0),
  from: yup.number().default(0),
  last_page: yup.number().default(0),
  links: yup.array().default([]),
  path: yup.string().default(""),
  per_page: yup.number().default(0),
  to: yup.number().default(0),
  total: yup.number().default(0)
});

// Esquema completo para la respuesta
const responseSchema = yup.object({
  data: yup.array().of(userSchema).required().default([]),
  links: paginationSchema.default({}),
  meta: metaSchema.default({}),
  message: yup.string().default("ok")
});

type UserType = yup.InferType<typeof userSchema> & IRemaxGlobalStatusSync;
type PaginationType = yup.InferType<typeof paginationSchema>;
type MetaType = yup.InferType<typeof metaSchema>;
type AgentListResponseType = yup.InferType<typeof responseSchema>;

export function transformResponseListUser(
  data: AgentListResponseType
): AgentListResponseType {
  try {
    return responseSchema.validateSync(data);
  } catch (error) {
    console.log("💥 Validation error at {getWorkOrderList}", error);
    return data;
  }
}
